import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CrateMetrics {
  viewCount: number;
  saveCount: number;
}

interface CrateMetricsState {
  [crateId: string]: CrateMetrics;
}

const initialState: CrateMetricsState = {};

const crateMetricsSlice = createSlice({
  name: 'crateMetrics',
  initialState,
  reducers: {
    updateCrateMetric: (
      state,
      action: PayloadAction<{
        crateId: string;
        metric: 'view' | 'save';
        confirmedCount: number;
      }>,
    ) => {
      const { crateId, metric, confirmedCount } = action.payload;
      if (!state[crateId]) {
        state[crateId] = { viewCount: 0, saveCount: 0 };
      }
      if (metric === 'view') {
        state[crateId].viewCount = Math.max(
          state[crateId].viewCount,
          confirmedCount,
        );
      } else {
        state[crateId].saveCount = Math.max(
          state[crateId].saveCount,
          confirmedCount,
        );
      }
    },
    seedCrateMetrics: (
      state,
      action: PayloadAction<{
        crateId: string;
        viewCount: number;
        saveCount: number;
      }>,
    ) => {
      const { crateId, viewCount, saveCount } = action.payload;
      if (!state[crateId]) {
        state[crateId] = { viewCount: 0, saveCount: 0 };
      }
      state[crateId].viewCount = Math.max(state[crateId].viewCount, viewCount);
      state[crateId].saveCount = Math.max(state[crateId].saveCount, saveCount);
    },
  },
});

export const { seedCrateMetrics, updateCrateMetric } =
  crateMetricsSlice.actions;
export default crateMetricsSlice.reducer;
